import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import PropTypes from 'prop-types';
import RoleGuard from "../components/RoleGuard";

const ResourceStatusDialog = ({ open, onClose, resource }) => {
  const [selectedDate, setSelectedDate] = useState(null);

   useEffect(() => {
    
  }, [resource]);

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const handleScheduleStart = () => {
    // Implement scheduling logic here
  };

  return (
    <Dialog open={open} onClose={onClose}>
       <DialogTitle sx={{ fontSize: '18px', fontWeight: 'Bold'}}>Resource Details</DialogTitle>
      <DialogContent>
        <Box sx={{ mb: 3, p: 2, bgcolor: '#f5f5f5', borderRadius: '8px' }}>
          <Typography variant="body1">
            <strong>Application Name:</strong> {resource.applicationName}
          </Typography>
          <Typography variant="body1">
            <strong>Resource Name:</strong> {resource.resourceName}
          </Typography>
          <Typography variant="body1">
            {/* <strong>Price:</strong> {resource.price || 'NA'} */}
          </Typography>
        </Box>

        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DateTimePicker
            label="Select Date & Time"
            value={selectedDate}
            onChange={handleDateChange}
            slotProps={{
              textField: { fullWidth: true }
            }}
          />
        </LocalizationProvider>

        <Box sx={{ mt: 3, p: 2, bgcolor: '#e3f2fd', borderRadius: '8px' }}>
          <Typography variant="body2">
            <strong>Start Schedule</strong>
          </Typography>
          <Typography variant="body2">
            The virtual machine "{resource.name}" will be started on {selectedDate ? selectedDate.toLocaleString() : '[selected date and time]'}.
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <RoleGuard requiredPermission="START_STOP">
        <Button onClick={handleScheduleStart} variant="contained" sx={{ bgcolor: '#4caf50', color: '#fff' }}>
          Schedule Start
        </Button>
        </RoleGuard>
        <Button onClick={onClose} variant="outlined" sx={{ ml: 1 }}>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};
ResourceStatusDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  resource: PropTypes.shape({
    applicationName: PropTypes.string.isRequired,
    resourceName: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
};

export default ResourceStatusDialog
